'use strict';

angular.module('mandaeApp')
  .controller('ModalForaAreaCtrl', function ($uibModalInstance, $scope) {

    $scope.fechar = function () {
      $uibModalInstance.dismiss();
    }

  });
